import { any, arrayOf, bool, shape, string } from 'prop-types';
import QuantityUnitType from './quantityUnitType';

const PastWeatherType = shape({
  accumulatedPrecipitation: shape({
    past: QuantityUnitType,
    historical: QuantityUnitType,
  }),
  endDate: any,
  formattedDates: arrayOf(any),
  precipitation: shape({
    past: QuantityUnitType,
    historical: QuantityUnitType,
    help: bool,
  }),
  startDate: any,
  temperature: shape({
    past: QuantityUnitType,
    historical: QuantityUnitType,
    help: bool,
  }),
  yearAverage: string,
  pastWeatherError: string,
});

export default PastWeatherType;
